export default {
  setUserDetails(state, value) {
    state.userDetails = value;
  },
  setApiAuth(state, value) {
    state.requestKey = value;
  },
  setMode(state, value) {
    state.mode = value;
  },
  setBankName(state, value) {
    state.bankNames = value;
  },
  setBankList(state, value) {
    state.bankList = value;
  },
  setSubAccounts(state, value) {
    state.subAccounts = value;
  },
  setUserRole(state, value) {
    state.userRole = value;
  },
  setSettlements(state, value) {
    state.settlements = value;
  },
  setFullSettlements(state, value) {
    state.fullSettlements = value;
  },
  setSettlementTransactions(state, value) {
    state.settlementTransactions = value;
  },
  setSettlementTransactionDetails(state, value) {
    state.settlementTransactionDetails = value;
  },
  setFullSettlementTransactions(state, value) {
    state.fullSettlementTransactions = value;
  },
  setSettlementDetail(state, value) {
    state.settlementDetail = value;
  },
  setSettlementBatchDetail(state, value) {
    console.log("vlue", value);
    state.settlementBatchDetail = value;
  },
  setRowSelected(state, { value, id, type }) {
    if (!type) {
      const newState = state.rowSelected.filter((rowId) => rowId !== id);
      if (value) {
        state.rowSelected = [...newState, id];
      } else {
        state.rowSelected = newState;
      }
    }

    if (type === "none") {
      state.rowSelected = [];
    }
  },
  setUnsettledTransactionsRowSelected(state, newState) {
    state.rowSelected = newState;
  },
  setSelectAllRows(state, { rows }) {
    state.rowSelected = rows;
  },
  setPayoutDashboard(state, value) {
    state.payoutDashboard = value;
  },
  setPayoutDetails(state, value) {
    state.payOutDetails = value;
  },
  setSingleDetails(state, value) {
    state.singlePayoutDetails = value;
  },
  setRoutingRules(state, value) {
    state.routingRules = value;
  },
  setMerchantRoutingRules(state, value) {
    state.merchantRoutingRules = value;
  },
  setMerchantSpecificRules(state, value) {
    state.merchantSpecificRules = value;
  },
  setDefaultCollectionAccount(state, value) {
    state.defaultCollectionAccount = value;
  },
  setFees(state, value) {
    state.fees = value;
  },
  setRules(state, value) {
    state.directDebitRules = value;
  },
  setDirectDebitCategories(state, value) {
    state.directDebitCategories = value;
  },
  setSettlementTranches(state, value) {
    state.settlementTranches = value;
  },
  setSettlementRetries(state, value) {
    state.settlementRetries = value;
  },
  setSubTitle(state, value) {
    state.subTitle = value;
  },
  setCustomMetaOptions(state, value) {
    state.customMetaOptions = value;
  },
  setTransactionTypes(state, value) {
    state.transactionTypes = value;
  },
  setPriorityConfigurationList(state, value) {
    state.priorityConfigList = value;
  },
  setMerchantAccess(state, payload) {
    state.merchantAccess[payload.merchantId] = payload.value;
  },
  setMerchantActiveLien(state, payload) {
    state.activeLien = payload;
  },
};
